import omit from 'hs-lodash/omit';
import some from 'hs-lodash/some';
import { SET_TEASE_IFRAME_DIMENSIONS } from '../actions/ActionTypes';
const initialState = {
  alerts: [],
  iframeDimensions: {
    height: 0,
    width: 0
  }
};
const teaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TEASE_IFRAME_DIMENSIONS:
      return Object.assign({}, state, {
        iframeDimensions: action.payload
      });
    case 'ADD_TEASE_ALERT':
      {
        const {
          id
        } = action;
        const alreadyExists = some(state.alerts, {
          id
        });
        if (!alreadyExists) {
          const newAlert = omit(action, ['type']);
          return Object.assign({}, state, {
            alerts: [...state.alerts, newAlert]
          });
        }
        return state;
      }
    case 'REMOVE_TEASE_ALERT':
      {
        const {
          id
        } = action;
        return Object.assign({}, state, {
          alerts: state.alerts.filter(thisAlert => thisAlert.id !== id)
        });
      }
    default:
      return state;
  }
};
export default teaseReducer;